import { useContext } from 'react';
import * as Button from '../../components/button/button';
import { inSyncMutation } from '../../hooks/use-sync';
import { useQuery } from '../../hooks/use-query';
import { GoldMaster } from '../../references/tenant';
import { TenantContext } from '../../state/tenant-state';
import { InSync } from '../../types/in-sync';
import { Icons } from '../icons/icons';

type Props = {
  path: string;
};

const RevertToMasterButton = (props: Props): JSX.Element => {
  const inSync = useQuery<InSync>({ path: `/${props.path}/in-sync` });
  const inSyncDelete = inSyncMutation(`/${props.path}/revert`);

  const onClick = (): void => {
    inSyncDelete.mutate('');
  };

  return <Button.TertiarySmall onClick={onClick} disabled={inSync.isLoading || inSyncDelete.isLoading || inSync.data?.inSync}>
    <Icons.Revert />
    Revert to Master
  </Button.TertiarySmall>;
};

export const RevertToMaster2 = (props: Props): JSX.Element => {
  const authContext = useContext(TenantContext);
  return authContext.current.id === GoldMaster ? <></> : <RevertToMasterButton path={props.path} />;
};
